export const ACCOUNTS_FETCHING = 'ACCOUNTS_FETCHING'
export const ACCOUNTS_FETCHED = 'ACCOUNTS_FETCHED'
export const ACCOUNTS_FAILED = 'ACCOUNTS_FAILED'
export const SYNCING_ACCOUNTS = 'SYNCING_ACCOUNTS'
export const ACCOUNTS_POLLING = 'ACCOUNTS_POLLING'
